import { environment } from '../../environments/environment';
import { combineLatest, forkJoin, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnInit, HostListener, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { APP_RESOLVER_PROVIDERS } from "./../app.resolver";
import { ClearanceItem, ListSearchData, MassUpdateData } from './index';
import { ILookup, LookupList } from '../shared/lookup';

import { ActivatedRoute, Router, NavigationEnd, NavigationStart } from '@angular/router';

import { AppService } from '../app.service';
import { DatePipe, Location, LocationStrategy, isPlatformBrowser, PlatformLocation } from "@angular/common"
import { CIImage, ClearanceItemTagComponent } from './index';
import { ClearanceItemService } from './clearance-item.service';
import { ComponentCanDeactivate, MessageBrokerService, AuthService } from '../shared/core/index';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { ClearanceItemAssetManagerComponent } from './asset-management/clearance-item-asset-manager.component';
import { CIDocument, CITag, CIAsset } from './clearance-item.model';
import { SharedUtils, DateUtils } from '../shared/utils';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import { ProjectItem } from '../project';
import { ReportsService } from '../reports/reports.service';
import { ReportBuilder } from '../reports/reports-builder.model';
import { ClearanceItemBulkComponent } from './bulk-action/clearance-item-bulk.component';
import { ModalService } from '../shared/helper-components/modal/_services/modal.service';
import { ProjectService } from '../project/project.service';
import { IProject } from '../project/project.model';
import { NavigationTrackerService } from '../shared/helper-components/navigation-tracker.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'clearance-list',
    standalone: false,
    templateUrl: './clearance-list.component.html',
    styleUrls: ['./clearance-list.component.css']
})
export class ClearanceListComponent implements OnInit {

    @ViewChild('tagComponent', { static: false }) tagComponent: ClearanceItemTagComponent;
    @ViewChild('imageAsset', { static: false }) imageComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('documentAsset', { static: false }) documentComponent: ClearanceItemAssetManagerComponent;
    @ViewChild('maincontainer', { static: false }) public maincontainer: ElementRef;
    @ViewChild('bulkAction', { static: false }) bulkActionComponent: ClearanceItemBulkComponent;
    @ViewChild('newItemFab', { read: MatTooltip, static: false }) newItemTooltip: MatTooltip;

    pageTitle: string = 'Clearance Items';
    isClearanceUser: boolean = false;
    isLoadingMoreRecords: boolean = false;
    listSearchData: ListSearchData;
    listSearchAllData: ListSearchData;
    massUpdateData: MassUpdateData = new MassUpdateData();
    itemList: ClearanceItem[] = [];
    completeitemList: ClearanceItem[] = [];
    showSpinner: boolean = false;
    statusLookup: ILookup[] = [];
    modalstatusLookup: ILookup[] = [];
    selectedItem: ClearanceItem;
    sortByLookup: ILookup[] =
        [{ id: "CreatedBy", name: 'Date Added', type: "" },
        { id: "Name", name: 'A-Z', type: "" },
        { id: "ModifiedDate", name: 'Date Modified', type: "" },
        { id: "Deadline", name: 'Deadline', type: "" },
        { id: "Status", name: 'Status', type: "" }];
    filterByLookup: ILookup[] =
        [{ id: "Keyword", name: 'Keyword', type: "" },
        { id: "Name", name: 'Name', type: "" },
        { id: "Number", name: 'Number', type: "" },
        { id: "Copyright", name: 'Copyright/Owner', type: "" },
        { id: "Artist/Author", name: 'Artist/Author', type: "" },
        { id: "Season", name: 'Season', type: "" },
        { id: "Episode", name: 'Episode', type: "" },
        { id: "ReportGroup", name: 'Report Group Name', type: "" },
        { id: "Tags", name: 'Tags', type: "" },
        { id: "Restrictions", name: 'Restrictions', type: "" },
        { id: "RefUrl", name: 'Reference URL', type: "" }];

    showMobileFilters: boolean = false;
    showTagsModal: boolean = false;
    /** Matches CSS breakpoint at 1024px — only one bulk-bar instance in the DOM (TR-008). */
    isMobileLayout: boolean = SharedUtils.IsMobile() as boolean;
    commentIsRequired: Boolean = false;
    defaultMessage: string = 'Enter criteria and hit \'Enter\' to search';
    noRecordsFoundMessage: string = 'No items found with the provided filters.';
    searchMessage: string = '';
    bulkDataList: Array<Object> = new Array<Object>();
    inErrorState: boolean = false;
    readonly maxDisplayedTags: number = 3;

    private routeScrollPositions: { [url: string]: number }[] = [];
    private subscriptions: Subscription[] = [];
    private wasPop: boolean = false;
    private previousNavigationUrl: string;

    carouselImages = [];
    public dataImages = [];
    showCarousel: boolean = false;
    currentCarouselIndex = 0;
    currentCarouselCiName: string;
    currentCiStatus: string;
    currentCiStatusComments: string;
    clearanceItem: ClearanceItem = new ClearanceItem();
    projectDepartment: string = "";
    currentQueryString: string;
    openCarouselCIId:string;
    openCarouselImageIndex:number = 0;

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _clearanceItemService: ClearanceItemService,
        private _appService: AppService,
        public _authService: AuthService,
        private _notificationsService: NotificationsService,
        private _messageBrokerService: MessageBrokerService,
        private location: Location,
        private fb: FormBuilder,
        private _reportService: ReportsService,
        private modalService: ModalService,
        private _errorHandler: GlobalErrorHandler,
        private _locStrat: LocationStrategy,
        platLocation: PlatformLocation,
        private _projectService: ProjectService,
        private navigationTracker: NavigationTrackerService,
        private cd: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
        this.searchMessage = this.defaultMessage;
        this.subscribeToChanges();
        this.setupAutoScrolling(platLocation);
    }

    subscribeToChanges() {

        this._messageBrokerService.subscribeToItemChanged().subscribe(i => {
            this.getClearanceItem(i.id);
        });

        this._messageBrokerService.subscribeToItemDeleted().subscribe(id => {
            let index = this.itemList.findIndex(i => i.id == id);
            if (index >= 0) {
                this.itemList.splice(index, 1);
            }
        });
    }

    setupAutoScrolling(platLocation: PlatformLocation) {

        platLocation.onPopState(() => {
            this.wasPop = true;
        });

        let self = this;

        this.subscriptions.push(
            self._router.events.subscribe((e) => {

                if (e instanceof NavigationStart) {
                    // VR-010: itemlist is route-cached; close carousel before detach so the
                    // body-hosted image-modal cannot survive onto the next route or reopen on attach.
                    if (self.showCarousel) {
                        self.showCarousel = false;
                        if (self.modalService.modalExists('image-modal-carousel')) {
                            self.modalService.close('image-modal-carousel');
                        }
                    }
                }

                if ((e instanceof NavigationStart) && self.selectedItemId) {

                    if (!self.isLinkActive('/projects'))
                        return;

                    let index = self.previousNavigationUrl !== null ? self.previousNavigationUrl : e.url;
                    self.routeScrollPositions[index] = window.pageYOffset;
                } else if (e instanceof NavigationEnd) {
                    if (!self._router.isActive('projects', false)) {
                        window.scrollTo(0, 0);
                        self.wasPop = false;
                        return;
                    }
                    self.previousNavigationUrl = e.url;
                    if (self.wasPop) {
                        if (!self.routeScrollPositions[e.url]) {
                            window.scrollTo(0, 0);
                            self.wasPop = false;
                            return;
                        }
                        setTimeout(() => {
                            window.scrollTo(0, self.routeScrollPositions[e.url] || 0);
                            // self._notificationsService.add(new Notification('info', 'window scroll for :\'' + e.url + '\' to:' + self.routeScrollPositions[e.url]));
                        }, 1000);
                        self.wasPop = false;

                    } else {
                        window.scrollTo(0, 0);
                    }
                };
            })
        );
    }

    public isLinkActive(url) {
        
        let charPos = this._router.url.indexOf('?');
        let cleanUrl = charPos !== -1 ? this._router.url.slice(0, charPos) : this._router.url;
        let itemsInUrl = cleanUrl.split('/');
        if (itemsInUrl.length == 4) {
            if (itemsInUrl[1] == 'projects' && itemsInUrl[3] == 'items')
                return true;
        }
        return false;
        // return (cleanUrl === url);
    }


    getClearanceItem(id: string): void {
        
        this.showSpinner = true;
        this._clearanceItemService.getCI(id)
            .subscribe
            (
                (data) => {
                    this.ngZone.run(() => {
                        this.onCIRetrieved(data);
                        this.selectedItemId = null;
                        this.showSpinner = false;
                        this.cd.detectChanges();
                    });
                },
            );
    }

    onCIRetrieved(data: ClearanceItem) {
        let item = this.itemList.findIndex(i => i.id == data.id);
        this.checkDefaultImage(data);
        if (item < 0)
            this.itemList.push(data);
        else
            this.itemList[item] = data;
    }

    ngOnInit(): void {

        this.isClearanceUser = this._authService.isUserInRole(environment.clearanceRole);// || !environment.production;
        if (!this.isClearanceUser) {
            var indexFilter = this.filterByLookup.findIndex(it => it.id == "ReportGroup");
            this.filterByLookup.splice(indexFilter, 1);
        }
        this.listSearchData = new ListSearchData();
        this.massUpdateData = new MassUpdateData();
        this.selectedItem = new ClearanceItem(); 
        // // Read the clearance Id from the route parameter
        var obsComb = combineLatest([this._route.params, this._route.queryParams]).pipe(
            map(([params, qparams]) => ({ params, qparams }))
        );

        obsComb.subscribe(
            combine => {
                let projectId = combine.params['projectId'];               
                let projectName = combine.qparams['projectName'];
                if (projectId) {
                    this.loadCILookups(projectId);
                    this.setProjectDepartment(projectId);                    
                    if (projectName) {
                        this._messageBrokerService.setCurrentProject(new ProjectItem(projectId, projectName), true);
                    }
                    this.listSearchData.projectId = projectId;
                    this.listSearchData.sortOrder = 'DESC';
                    let statusParam = combine.qparams['status'];
                    this.listSearchData.status = statusParam || 'All';
                    let sortByParam = combine.qparams['sortBy'];
                    if (sortByParam)
                        this.listSearchData.sortBy = sortByParam;
                    let sortOrder = combine.qparams['sortOrder'];
                    if (sortOrder)
                        this.listSearchData.sortOrder = sortOrder;
                    if (sortOrder == 'DESC') {
                        this.sortOrderIcon = 'arrow_downward';
                        this.sortOrderTooltip = 'sort asc';
                    }
                    else if (sortOrder == 'ASC') {
                        this.sortOrderIcon = 'arrow_upward';
                        this.sortOrderTooltip = 'sort desc';
                    }

                    let filterBy = combine.qparams['filterBy'];
                    this.listSearchData.filterBy = filterBy || this.filterByLookup[0].id;
                    let filterString = combine.qparams['filterString'];
                    if (filterString)
                        this.listSearchData.filterString = filterString;
                    let hasNotes = combine.qparams['hasNotes'];
                    if (hasNotes)
                        this.listSearchData.hasNotes = hasNotes === 'true';
                    let hasUnreadNotes = combine.qparams['hasUnreadNotes'];
                    if (hasUnreadNotes)
                        this.listSearchData.hasUnreadNotes = hasUnreadNotes === 'true';
                
                    this.openCarouselCIId = combine.qparams['ciId'];
                    const openImageIndex = parseInt(combine.qparams['imageIndex']);
                    this.openCarouselImageIndex = isNaN(openImageIndex) ? null : openImageIndex;
                    this.filterChanged('onLoad');
                    this.setCurrentQueryString();
                }
            }
        );

        this._appService.scrollBottomReachedEvent.subscribe(()=>{
            this.loadMoreRecords();
        })
        this.loadAllRecords();
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy()');
    }

    setStatusClasses(item) {
        let cssClasses =
        {
            'not-clear': item.status == 'NOT CLEAR'  || item.status == 'DENIED',
            'clear': (item.status && item.status.includes('CLEAR') && item.status != 'NOT CLEAR' && item.status != 'PERMISSIBLE - Graphics Require Review') || item.status=='PERMISSIBLE' || item.status == 'PERMISSIBLE - Background Use Only' || item.status == 'APPROVED',
            'new': item.status == 'NEW',
            'abandoned': item.status == 'ABANDONED',
            'pending': item.status && item.status == 'PERMISSIBLE - Graphics Require Review' || item.status.includes('PENDING') || item.status == 'DEFERRED'
        };
        return cssClasses;
    }

    get IsSearchMessageDefault(): Boolean {
        return this.searchMessage === this.defaultMessage;
    }

    sortOrderTooltip = 'sort desc';
    sortOrderIcon = 'arrow_downward';

    filterChanged(filterType: string): void {

        // console.log('sortOrderTooltip:' + this.sortOrderTooltip);
        window.scrollTo(0, 0);
        if (filterType == 'sortBy' && this.listSearchData.sortBy == "Status") {
            this.listSearchData.sortOrder = 'ASC';
            this.sortOrderIcon = 'arrow_upward';
            this.sortOrderTooltip = 'sort desc';
        }

        if (filterType == 'sortOrder') {
            if (!this.listSearchData.sortOrder || this.listSearchData.sortOrder == 'ASC') {
                this.listSearchData.sortOrder = 'DESC';
                this.sortOrderIcon = 'arrow_downward';
                this.sortOrderTooltip = 'sort asc';
            }
            else {
                this.listSearchData.sortOrder = 'ASC';
                this.sortOrderIcon = 'arrow_upward';
                this.sortOrderTooltip = 'sort desc';
            }
        }
        else if (filterType == 'clear') {
            this.listSearchData.filterBy = this.filterByLookup[0].id;
            this.listSearchData.sortBy = this.sortByLookup[0].id;
            this.listSearchData.sortOrder = null;
            this.listSearchData.filterString = null;
            this.listSearchData.status = this.statusLookup[0].id;
            this.listSearchData.hasNotes = false;
            this.listSearchData.hasUnreadNotes = false;
        }

        if (!this.listSearchData.filterBy) {
            this.listSearchData.filterBy = this.filterByLookup[0].id;
        }
        if (!this.listSearchData.status) {
            this.listSearchData.status = 'All';
        }

        this.listSearchData.pazesize = 10;
        this.listSearchData.pageStartIndex = 0;
        this.listSearchData.totalNumberOfRecords = 0;
        // console.log(this.listSearchData);
        this.getItemList();
        if (filterType != 'onLoad') {
            this.updateRouteURL();
            this.setCurrentQueryString();
        }
    }

    updateRouteURL(): void {
        if (this.listSearchData && this.listSearchData.projectId) {
            let newUrl = '/projects/' + this.listSearchData.projectId + '/items';
            if (this.listSearchData.sortBy) {
                newUrl += '?sortBy=' + this.listSearchData.sortBy;
            }
            else {
                newUrl += '?sortBy=CreatedDate';
            }
            if (this.listSearchData.sortOrder) {
                newUrl += '&sortOrder=' + this.listSearchData.sortOrder;
            }
            if (this.listSearchData.status) {
                newUrl += '&status=' + this.listSearchData.status;
            }

            if (this.listSearchData.filterBy && this.listSearchData.filterString) {
                newUrl += '&filterBy=' + this.listSearchData.filterBy;
                newUrl += '&filterString=' + this.listSearchData.filterString;
            }
            if (this.listSearchData.hasNotes) {
                newUrl += '&hasNotes=true';
            }
            if (this.listSearchData.hasUnreadNotes) {
                newUrl += '&hasUnreadNotes=true';
            }
            this.location.replaceState(newUrl);
            this._appService.listViewURL = newUrl;
            this.navigationTracker.rememberCiListSearch(newUrl);
            console.log(this._appService.listViewURL);
        }
    }
    setCurrentQueryString(): void {
        if (this.listSearchData && this.listSearchData.projectId) {
            let queryString = '';
            if (this.listSearchData.sortBy) {
                queryString += '?sortBy=' + this.listSearchData.sortBy;
            }
            else {
                queryString += '?sortBy=CreatedDate';
            }
            if (this.listSearchData.sortOrder) {
                queryString += '&sortOrder=' + this.listSearchData.sortOrder;
            }
            if (this.listSearchData.status) {
                queryString += '&status=' + this.listSearchData.status;
            }

            if (this.listSearchData.filterBy && this.listSearchData.filterString) {
                queryString += '&filterBy=' + this.listSearchData.filterBy;
                queryString += '&filterString=' + this.listSearchData.filterString;
            }
            if (this.listSearchData.hasNotes) {
                queryString += '&hasNotes=true';
            }

            this.currentQueryString = queryString;
            // Keep cancel-from-CI target aligned even when onLoad skips updateRouteURL
            const listUrl = '/projects/' + this.listSearchData.projectId + '/items' + queryString;
            this._appService.listViewURL = listUrl;
            this.navigationTracker.rememberCiListSearch(listUrl);
        }
    }

    stopPropagation(e): void {
        e.stopPropagation();
    }
    selectAllItems(e): void {
        if (this.itemList) {
            if (e.checked) {
                this.itemList.forEach(it => it.isSelected = true);
            }
            else {
                this.itemList.forEach(it => it.isSelected = false);
            }
        }
    }
    private toListRequest(data: ListSearchData): ListSearchData {
        const requestData = { ...data };
        const hasFilterString = !!(requestData.filterString && String(requestData.filterString).trim());
        if (!hasFilterString) {
            requestData.filterBy = null;
        }
        return requestData;
    }

    getItemList(): void {

        
        this.showSpinner = true;
        this.searchMessage = '';
        this.listSearchData.filterString = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd');
        this.inErrorState = false;
        this._clearanceItemService.getCIList(this.toListRequest(this.listSearchData))
            .subscribe
            (
                (data) => {
                    this.ngZone.run(() => {
                        if (!data.resultSet || data.resultSet.length == 0) {
                            this.searchMessage = this.noRecordsFoundMessage;
                        }
                        this.onListDataRetrieved(data);
                        this.showSpinner = false;
                        this.cd.detectChanges();
                    });
                },
                (error: any) => {
                    this.ngZone.run(() => {
                        this.itemList = [];
                        this.selectedItemId = null;
                        this.showSpinner = false;
                        if (error.status == 404) {
                            this.searchMessage = this.noRecordsFoundMessage;
                        } else {
                            this._errorHandler.processError(error);
                        }
                        this.inErrorState = true;
                        this.cd.detectChanges();
                    });
                }
            );

    }

    private selectedItemId: string;
    openItemDetails(itemId: string): void {
        this.selectedItemId = itemId;
        this._router.navigateByUrl('/projects/' + this.listSearchData.projectId + '/items/' + itemId);
    }

    @HostListener('window:resize')
    onWindowResize(): void {
        this.isMobileLayout = SharedUtils.IsMobile() as boolean;
    }

    @HostListener("window:scroll")
    public onWindowScroll() {
        if (this.isBottomReached()) {
            //code when scroll reached end
            // console.log('scroll reached end');
            this.loadMoreRecords();
        }
    }


    isBottomReached(): Boolean {
        let windowHeight = "innerHeight" in window ? window.innerHeight
            : document.documentElement.offsetHeight;
        let body = document.body, html = document.documentElement;
        let docHeight = Math.max(body.scrollHeight,
            body.offsetHeight, html.clientHeight,
            html.scrollHeight, html.offsetHeight);
        let windowBottom = windowHeight + window.pageYOffset;
        if (windowBottom >= docHeight) {
            return true;
        }
        return false;
    }

    moreRecords(): boolean {
        if (!this.isLoadingMoreRecords && this.listSearchData.projectId) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            return this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000;
        }

        return false;
    }

    manualLoad(): void {
        this.loadMoreRecords();
        setTimeout(() => {
            this.maincontainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        });
    }

    loadMoreRecords(): void {
        
        if (!this.isLoadingMoreRecords && this.listSearchData.projectId) {
            let nextPageRecordStartIndex = this.listSearchData.pazesize + this.listSearchData.pageStartIndex;
            //if there are more records to fetch
            if (this.listSearchData.totalNumberOfRecords > nextPageRecordStartIndex && nextPageRecordStartIndex < 2000) {
                this.isLoadingMoreRecords = true;
                this.listSearchData.pageStartIndex = nextPageRecordStartIndex;
                this.listSearchData.filterString = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd');
                this.inErrorState = false;
                this._clearanceItemService.getCIList(this.toListRequest(this.listSearchData))
                    .subscribe
                    (
                        (data) => {
                            this.ngZone.run(() => {
                                this.isLoadingMoreRecords = false;
                                if (data.resultSet) {
                                    this.listSearchData.totalNumberOfRecords = data.totalNumberOfRecords;
                                    this.listSearchData.pageStartIndex = data.pageStartIndex;
                                    data.resultSet.forEach(it => {
                                        it.deadline = DateUtils.toDateFromString(it.deadline, 0, 1, 2, 'MM-dd-yyyy', '-');
                                        this.itemList.push(this.checkDefaultImage(it));
                                    });

                                    console.log(this.itemList.length);
                                }
                                this.cd.detectChanges();
                            });
                        },
                        (error: any) => {
                            this.ngZone.run(() => {
                                this.isLoadingMoreRecords = false;
                                this.itemList = [];
                                this.selectedItemId = null;
                                if (error.status == 404) {

                                } else {
                                    this._errorHandler.processError(error);
                                }
                                this.inErrorState = true;
                                this.cd.detectChanges();
                            });
                        }
                    );
            }

        }
    }
    onListDataRetrieved(listSearchData: ListSearchData): void {
        
        console.log(listSearchData);
        this.itemList = [];
        this.selectedItemId = null;
        if (listSearchData.resultSet) {
            listSearchData.resultSet.forEach(item => {
                item.deadline = DateUtils.toDateFromString(item.deadline, 0, 1, 2, 'MM-dd-yyyy', '-'),
                    this.itemList.push(this.checkDefaultImage(item));
            });

            this.listSearchData.totalNumberOfRecords = listSearchData.totalNumberOfRecords;
            this.listSearchData.pageStartIndex = listSearchData.pageStartIndex;

            if (listSearchData.totalNumberOfRecords > 0) { this.selectedItem = listSearchData.resultSet[0]; }
        }
    }

    showAllTags(item: ClearanceItem): void {
        this.selectedItem = item;
        this.showTagsModal = true;
    }


    checkDefaultImage(item: ClearanceItem): ClearanceItem {
        if (item) {
            
            if (item.images && item.images.length > 0) {
                //determine default image
                let imagesOnly = item.images.filter(i => i.assetType.toLowerCase() === 'image' &&  SharedUtils.FileTypeIsImage(i.fileType));
                let attachments = item.images.filter(i => i.assetType.toLowerCase() === 'image');
                item.defaultImage = imagesOnly.find(i => i.defaultC == true);
                if (!item.defaultImage && imagesOnly.length > 0)
                    item.defaultImage = imagesOnly[0];
                else {
                    item.defaultImage = attachments[0];

                    if (item.defaultImage && item.defaultImage.relatedImages){
                        item.defaultImage.relatedImages.forEach(ri => {
                            if(ri.fileType.endsWith('pdf'))
                                ri.fullUrl = '../../assets/images/PDF_file_icon.png';
                        });
                    }
                    
                    if (item.defaultImage && item.defaultImage.fileType.endsWith('pdf'))
                        item.defaultImage.fullUrl = '../../assets/images/PDF_file_icon.png';
                    else if (item.defaultImage && !SharedUtils.FileTypeIsImage(item.defaultImage.fileType)) 
                        item.defaultImage.fullUrl = '../../assets/images/attachment-icon.jpg';                   
                }
            }
            else {
                //add default image
                item.images = [];
                let image = new CIImage();
                // image.fullUrl='https://s3.amazonaws.com/uifaces/faces/twitter/brad_frost/128.jpg';
                item.images.push(image);
            }
        }
        return item;
    }

    loadFinished(img) {
    }

    hideBrokenImage(event): void {
        const imgEl = event && event.target ? event.target as HTMLImageElement : null;
        if (imgEl) {
            imgEl.style.display = 'none';
        }
    }

    loadCILookups(projectId :string): void {
        
        this._appService.retrieveCILookups(undefined, projectId)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {
                    this._errorHandler.processError(error);
                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        
        if (list && list.length > 0) {
            this.statusLookup = [];
            if (list.find(it => it.lookupType == 'CIStatus') != null && list.find(it => it.lookupType == 'CIStatus').lookupData) {
                this.modalstatusLookup = list.find(it => it.lookupType == 'CIStatus').lookupData;
                list.find(it => it.lookupType == 'CIStatus').lookupData.forEach(look => this.statusLookup.push(look));
                let staticLookup = new ILookup('All', 'All');
                this.statusLookup.splice(0, 0, staticLookup);

                if(!this._authService.secondApproval){
                    staticLookup = new ILookup('Urgent', 'Urgent');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Pending', 'All Pending');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Clear', 'All Clear');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                }                             
            }
        }

    }

    initializeAllTagModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.massUpdateData.updateType = 'AddTags';
            this.massUpdateData.tags = [];
            this.tagComponent.loadTagLookups();
            this.showTagsModal = true;
        }
    }

    onModalInitRequest(modalId: string) {
        if (modalId === 'modal-status') {
            this.initializeStatusModal();
        } else if (modalId === 'modal-groupName') {
            this.initializeGroupNameModal();
        } else if (modalId === 'modal-tag') {
            this.initializeTagModal();
        } else if (modalId === 'modal-release') {
            this.initializeDocModal();
        } else if (modalId === 'modal-image') {
            this.initializeImageModal();
        } else {
            console.error('Did not understand the modal Id request:' + modalId);
        }
    }

    initializeStatusModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = this.modalstatusLookup;
            this.currentBulkModalId = 'modal-status';
            this.bulkActionComponent.setForm(this.initStatusForm());
            this.bulkActionComponent.initializeModal('modal-status', this.changeStatus.bind(this));
        }
    }

    initStatusForm(): FormGroup {
        let f = this.fb.group(
            {
                status: this._authService.secondApproval ? 'APPROVAL PENDING' : 'NEW',
                comments: ''
            });

        this.bulkActionComponent.showComments = this.statusRequiresComments(f.controls.status.value);

        f.controls.status.valueChanges.subscribe(v => {
            this.bulkActionComponent.showComments = this.statusRequiresComments(v);
           if (this.bulkActionComponent.showComments) {
                if (!this._authService.secondApproval){
                    f.controls.comments.setValidators([Validators.required, Validators.minLength(3), Validators.maxLength(255)]);
                }
            } else {
                f.controls.comments.clearValidators();
            }
            f.controls.comments.updateValueAndValidity();
        });

        return f;
    }

    statusRequiresComments(status: string): boolean {
        return status === 'DENIED' || status === 'DEFERRED' || status === 'PENDING - Production Info Required' || status === 'PENDING - Modifications Required';
    }

    currentBulkModalId = '';
    initializeGroupNameModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.currentBulkModalId = 'modal-groupName';
            this.bulkActionComponent.initializeModal('modal-groupName', this.updateGroupName.bind(this));
        }
    }

    initializeTagModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-tag';
            this.bulkActionComponent.initializeModal('modal-tag', this.addTags.bind(this));
        }

    }

    initializeImageModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-image';
            this.bulkActionComponent.initializeModal('modal-image', this.addImages.bind(this));
        }

    }

    initializeDocModal(): void {
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {
            this.bulkDataList = [];
            this.currentBulkModalId = 'modal-release';
            this.bulkActionComponent.initializeModal('modal-release', this.addDocuments.bind(this));
        }

    }

    generateReport(): void {
        var reportGenerateParams = this.getRequestParams();
        this._reportService.generateReports(reportGenerateParams)
            .subscribe(
                (res) => {
                    console.log('queued: ' + res);
                    this._notificationsService.add(new Notification('success', 'Your report has been submitted for processing, please check the Reports page.'));
                    this.showSpinner = false;
                },
                (error: any) => {
                    var e = JSON.stringify(error);
                    if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
                    }else{
                        this._errorHandler.processError(error);
                    }
                }
            );
    }

    getRequestParams(): ReportBuilder {
        var retValue = new ReportBuilder();
        retValue.searchByValue = DateUtils.tryToFormatStringToDateFormat(this.listSearchData.filterString, 'yyyy-MM-dd') || '';
        if (!retValue.searchByValue) {
            retValue.searchBy = 'All';
        } else {
            retValue.searchBy = this.listSearchData.filterBy;
        }
        retValue.projectId = this.listSearchData.projectId;
        retValue.sortedBy = this.listSearchData.sortBy;
        retValue.sortDirection = this.listSearchData.sortOrder;
        if (this.listSearchData.status) {
            retValue.status = this.listSearchData.status;
        }
        else {
            retValue.status = 'All';
        }
        if (this.anyItemSelected()){
            retValue.selectedIDs = this.getSelectedCIIds();
        }
        retValue.reportName = 'cilistreport';
        retValue.reports = [];
        return retValue;
    }


    addTags(selectedTags: CITag[]): void {
        
        if (selectedTags && selectedTags.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddTags';
            this.massUpdateData.tags = [];

            this.massUpdateData.tags = selectedTags;
            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => {
                if (it.isSelected)
                    this.massUpdateData.clearanceItems.push(it.id)
            });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with tags '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }
    createNewItem(): void {
        if (this.newItemTooltip) {
            this.newItemTooltip.hide(0);
        }
        // hide(0) is async (setTimeout); detach any visible overlay before navigation
        // so it cannot remain orphaned when the list component is destroyed.
        SharedUtils.RemoveMatTooltipOverlays();
        this._router.navigate(['projects', this.listSearchData.projectId, 'items', 'new']);
    }
    addImages(selectedImages: CIAsset[]): void {
        
        if (selectedImages && selectedImages.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddImages';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = [];

            selectedImages.forEach(it => {
                it.fullUrl = '';
                it.defaultC = false;
                it.assetType = 'Image';
            });
            this.massUpdateData.images = selectedImages;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = this.listSearchData.projectId;
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected images are added to selected items '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }
    addDocuments(selectedDocs: CIAsset[]): void {
        
        if (selectedDocs && selectedDocs.length > 0 && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'AddDocuments';
            this.massUpdateData.images = [];
            this.massUpdateData.documents = <CIDocument[]>selectedDocs;
            this.massUpdateData.clearanceItems = [];
            this.massUpdateData.projectId = this.listSearchData.projectId;
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected documents are added to selected items '));
                            this.filterChanged('onLoad');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    changeStatus(status: FormGroup) {
        
        console.log(this.massUpdateData);
        if (this.massUpdateData.status != 'All' && this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'ChangeStatus';
            this.massUpdateData.statusChangeComments = status.value.comments;
            this.massUpdateData.status = status.value.status;

            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe
                (
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items are updated with status ' + this.massUpdateData.status));
                            this.filterChanged('onLoad');
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        this._errorHandler.processError(error);
                    }
                );
        }
    }

    updateGroupName(groupName: FormGroup): void {
        
        if (this.itemList && this.itemList.filter(it => it.isSelected).length > 0) {

            this.massUpdateData.updateType = 'GroupName';
            this.massUpdateData.groupName = groupName.value.reportGroupName;

            this.massUpdateData.clearanceItems = [];
            this.itemList.forEach(it => { if (it.isSelected) this.massUpdateData.clearanceItems.push(it.id) });
            this.showSpinner = true;
            this._clearanceItemService.massUpdateItems(this.massUpdateData)
                .subscribe(
                    (data) => {
                        this.showSpinner = false;
                        if (data) {
                            this._notificationsService.add(new Notification('success', 'Selected Items were updated with Group Name \'' + this.massUpdateData.groupName + '\''));
                            this.filterChanged('onLoad');
                            this._messageBrokerService.sendMessageToRefreshLeftNav('');
                        }

                    },
                    (error: any) => {
                        this.showSpinner = false;
                        // this._errorHandler.processError(error);
                    }
                );
        }
    }

    anyItemSelected(): boolean {
        let isSelected = this.itemList && this.itemList.filter(it => it.isSelected).length > 0;
        return isSelected;
    }

    get allItemsSelected(): boolean {
        let ret = this.itemList.filter(i => i.isSelected === true).length === this.itemList.length;
        // console.log('ret: ' + ret);
        return ret && this.itemList.length > 0;
    }

    tagsString(item: ClearanceItem): string {
        if (item.tags)
            return item.tags.map(t => t.tagName).join(',');
        return '';
    }

    stringTitle(item): string {
        return item.titles.filter(t => !!!t.isDefault && item.name != t.name) .map(t => t.name).join(', ');
    }

    getSelectedCIIds(): string{
        return "##" + this.itemList.filter(it => it.isSelected).map(item => item.id).join("##") + "##";
    }

    moreTitlesVisible(item: ClearanceItem){
        if (item.titles && item.titles.length>0){
            return item.titles.filter(t => !!!t.isDefault && item.name != t.name).length > 0
        }
    }

    openCarousel(item: ClearanceItem, event?: Event){
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (this.modalService.modalExists('image-modal-carousel')){
            this.modalService.remove('image-modal-carousel');
        }
        this.showCarousel = false;
        this.showSpinner = true;
        this._clearanceItemService.getCI(item.id, true).subscribe({
            next: (ci) => {
                this.onSingleCIRetrieved(ci);
                this.showSpinner = false;
                if (!this.carouselImages || this.carouselImages.length === 0) {
                    this._notificationsService.add(new Notification('warn', 'This Clearance Item has no images to show', '', false));
                    return;
                }
                const listUrl =
                    (item.defaultImage && item.defaultImage.url) ||
                    (item.images && item.images[0] && item.images[0].url) ||
                    null;
                const default_index = listUrl
                    ? this.carouselImages.findIndex(img => img.url == listUrl)
                    : 0;
                this.currentCarouselIndex = default_index < 0 ? 0 : default_index;
                this.showCarousel = true;
                this.cd.detectChanges();
                // Modal registers under *ngIf on the next tick (TR-003 race).
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => {
                        this.ngZone.run(() => {
                            if (this.modalService.modalExists('image-modal-carousel')) {
                                this.modalService.open('image-modal-carousel');
                            }
                        });
                    });
                });
            },
            error: (error) => {
                this.showSpinner = false;
                this._errorHandler.processError(error);
            }
        });
    }

    onSingleCIRetrieved(ci: ClearanceItem): void {
        if (ci) {
            this.clearanceItem = ci;
            this.currentCarouselCiName = ci.name;
            this.currentCiStatus = ci.status;
            this.currentCiStatusComments = ci.statusChangeComments;
            this.carouselImages = [];
            if (this.clearanceItem && this.clearanceItem.images && this.clearanceItem.images.length > 0) {
                this.clearanceItem.images.forEach(img => {
                    const assetType = (img.assetType || '').toLowerCase();
                    const isImageAsset = assetType === 'image' || assetType === '';
                    const ft = img.fileType || '';
                    const looksLikeImage = !!ft && (
                        SharedUtils.FileTypeIsImage(ft) ||
                        ft.toLowerCase().endsWith('pdf')
                    );
                    if (isImageAsset || looksLikeImage) {
                        img.originalImageFullUrl = img.fullUrl || img.originalFullUrl || img.mediumImageFullUrl;
                        this.carouselImages.push(img);
                    }
                });
            }
        }
    }

    closeCarousel($event){
        this.showCarousel = false;
    }

    setProjectDepartment(projectId: string): void {
        this._projectService.getProject(projectId)
            .subscribe((project: IProject) => {
                this.projectDepartment = project.department;
            },
                (error: any) => {
                    this._errorHandler.processError(error);
                }
            );
    }

    loadAllRecords(): void {
        this.listSearchAllData = this.toListRequest(this.listSearchData);
        this.listSearchAllData.allRecords = true;
        this._clearanceItemService.getCIList(this.listSearchAllData)
            .subscribe
            (
                (data) => {
                    if (data.resultSet) {
                        data.resultSet.forEach(it => {
                            this.completeitemList.push(this.checkDefaultImage(it));
                        });
                        this.openCarouselFromAnnotation();
                    }
                },
                (error: any) => {
                    this.completeitemList = [];
                    if (error.status == 404) {

                    } else {
                        this._errorHandler.processError(error);
                    }
                }
            );
     
    }

    ciStatusChange($event){
        var ci = this.itemList.find(ci => ci.id == $event.ciId);
        if (ci){
            ci.status = $event.ciStatus;
        }
    }

    openCarouselFromAnnotation(){
        if (!this.openCarouselCIId)
            return;
        if (this.openCarouselImageIndex == undefined || this.openCarouselImageIndex == null || isNaN(this.openCarouselImageIndex))
            return;

        let ci = this.completeitemList.find(ci => ci.id == this.openCarouselCIId);
        if (!ci){
            return;
        }
        if (this.modalService.modalExists('image-modal-carousel')){
            this.modalService.remove('image-modal-carousel');
        }

        this.showCarousel = false;
        this.showSpinner = true;
        this._clearanceItemService.getCI(ci.id, true).subscribe({
            next: (fullCi) => {
                this.onSingleCIRetrieved(fullCi);
                this.showSpinner = false;
                if (!this.carouselImages || this.carouselImages.length === 0) {
                    this._notificationsService.add(new Notification('warn', 'This Clearance Item has no images to show', '', false));
                    return;
                }
                this.currentCarouselIndex = this.openCarouselImageIndex;
                this.showCarousel = true;
                this.cd.detectChanges();
                this.ngZone.runOutsideAngular(() => {
                    setTimeout(() => {
                        this.ngZone.run(() => {
                            if (this.modalService.modalExists('image-modal-carousel')) {
                                this.modalService.open('image-modal-carousel');
                            }
                        });
                    });
                });
            },
            error: (error) => {
                this.showSpinner = false;
                this._errorHandler.processError(error);
            }
        });
    }

    updateImageDetails(event){
        let ciImage : CIImage = event.ciImage;
        let ci = this.itemList.find(ci => ci.id == ciImage.cIId);
        if (ci){
            ci.hasNotes = event.itemHasNotes;
            ci.fonts = event.fonts
        }
    }
}
